import * as React from "react";
import Chip from "@mui/material/Chip";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";

export default function MultiSelectDropDown({
  data,
  handleSelected,
  value,
  placeholder,
  ...props
}) {
  return (
    <Stack spacing={3} sx={{ width: 400 }}>
      <Autocomplete
        {...props}
        multiple
        id="tags-outlined"
        options={data}
        getOptionLabel={(option) => option.name}
        onChange={handleSelected}
        value={value}
        filterSelectedOptions
        renderInput={(params) => (
          <TextField
            {...params}
            label={placeholder}
            placeholder={placeholder}
          />
        )}
      />
    </Stack>
  );
}
